/**
 * 改为从环境变量中获取，之前的先注释，方便对比确认环境变量是否正确
 *
 **/

const reg = /:\/\/(net\.comein\.cn|resource\.comein\.cn|brm\.comein\.cn)/i;

export const isBuild =
  ENV_DATA.VITE_APP_ENV?.includes('production') ||
  reg.test((typeof location?.href === 'string' ? location.href : '').toLowerCase());
// 路演直播厅地址
// let roadshowHost;
// let mainHost;
// let brmMainHost;
// let brmAiHost;
// let comeinEnv;
// let mobileHost;

// if (isBuild) {
//   roadshowHost = 'https://www.comein.cn';
//   // 官网服务地址
//   mainHost = 'https://server.comein.cn';
//   // brm服务地址
//   brmMainHost = 'https://brm.comein.cn';
//   // Ai服务地址
//   brmAiHost = 'https://sse.comein.cn';
//   comeinEnv = 'production';
//   //mobile服务地址
//   mobileHost = 'https://mobile.comein.cn';
// } else {
//   roadshowHost = 'https://testportal.comein.cn';
//   mainHost = 'https://testserver.comein.cn';
//   brmMainHost = 'https://test-brm.comein.cn';
//   brmAiHost = 'https://sse-test.comein.cn';
//   comeinEnv = 'development';
//   mobileHost = 'https://testmobile.comein.cn';
// }
// const comeinStaticCDN = 'https://image.comein.cn/web/brm/';
export const ROADSHOW_URL_HOST = ENV_DATA.VITE_HOST_ROADSHOW;
export const MAIN_URL_HOST = ENV_DATA.VITE_SERVER_MAIN;
export const BRM_URL_HOST = ENV_DATA.VITE_BRM_MAIN;
export const BRM_AL_URL_HOST = ENV_DATA.VITE_BRM_AI_MAIN;
export const COMEIN_STATIC_CDN = ENV_DATA.VITE_COMEIN_STATIC_CDN;
export const COMEIN_ENV = ENV_DATA.VITE_COMEIN_ENV;
export const MOBILEHOST = ENV_DATA.VITE_MOBILE_MAIN;
